class AddCreditsSystem {
  constructor() {
    this.storageKey = 'generated_codes';
    this.paymentStorageKey = 'verified_payments';
    // Always use the current domain for API calls
    this.apiBaseUrl = window.location.origin;
    this.ensureStorageExists();
    this.ensurePaymentStorageExists();
  }

  // Make sure our storage exists
  ensureStorageExists() {
    if (!localStorage.getItem(this.storageKey)) {
      localStorage.setItem(this.storageKey, JSON.stringify({
        codes: [],
        lastUpdated: new Date().toISOString()
      }));
    }
  }

  ensurePaymentStorageExists() {
    if (!localStorage.getItem(this.paymentStorageKey)) {
      localStorage.setItem(this.paymentStorageKey, JSON.stringify({
        payments: [],
        lastUpdated: new Date().toISOString()
      }));
    }
  }

  // Generate a random 5-character code
  generateCode() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let code = '';
    for (let i = 0; i < 5; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }

  // Check if a code already exists
  isCodeUsed(code) {
    const data = JSON.parse(localStorage.getItem(this.storageKey));
    return data.codes.includes(code);
  }

  // Check if payment was already verified
  isPaymentVerified(code) {
    const data = JSON.parse(localStorage.getItem(this.paymentStorageKey));
    return data.payments.some(p => p.code === code);
  }

  // Generate a unique code
  generateUniqueCode() {
    let code;
    let attempts = 0;
    const maxAttempts = 1000; // Prevent infinite loops

    do {
      code = this.generateCode();
      attempts++;
      if (attempts >= maxAttempts) {
        throw new Error('Could not generate unique code after 1000 attempts');
      }
    } while (this.isCodeUsed(code));

    // Save the new code
    const data = JSON.parse(localStorage.getItem(this.storageKey));
    data.codes.push(code);
    data.lastUpdated = new Date().toISOString();
    localStorage.setItem(this.storageKey, JSON.stringify(data));

    return code;
  }

  // Get all used codes
  getUsedCodes() {
    const data = JSON.parse(localStorage.getItem(this.storageKey));
    return data.codes;
  }

  // Process code and update credits
  async verifyPayment(code, expectedAmount, userId) {
    try {
      console.log('Starting verification with:', {
        code,
        expectedAmount,
        userId,
        apiUrl: `${this.apiBaseUrl}/api/user-action`
      });

      // First check if already verified
      if (this.isPaymentVerified(code)) {
        console.log('Already processed');
        return { verified: true, message: 'This has already been processed' };
      }

      // Make API call to backend
      console.log('Making API request...');
      const response = await fetch(`${this.apiBaseUrl}/api/user-action`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          action: 'add_balance',
          code,
          expectedAmount,
          user_id: userId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('API Response:', result);

      if (result.success && result.verified) {
        console.log('Successfully processed, storing in local storage');
        // Store verified payment
        const data = JSON.parse(localStorage.getItem(this.paymentStorageKey));
        data.payments.push({
          code,
          amount: expectedAmount,
          verifiedAt: new Date().toISOString()
        });
        localStorage.setItem(this.paymentStorageKey, JSON.stringify(data));
      }

      return {
        verified: result.verified,
        message: result.message || 'Please try again in a moment'
      };
    } catch (error) {
      console.error('Processing error:', error);
      return { 
        verified: false, 
        message: 'Unable to process. Please try again.' 
      };
    }
  }
}

export default new AddCreditsSystem(); 